import { Pipe, PipeTransform } from '@angular/core';



const lookup = {
  0: 'Eve User',
  1: 'IVR',
  2: 'Hunt Group',
  3: 'Call Queue',
  4: 'Sip Trunk',
  5: 'Group Voicemail',
  6: 'Teams Trunk'
};



@Pipe({
  name: 'ownerTypeIdToString'
})
export class OwnerTypeIdToStringPipe implements PipeTransform {
  transform(value: string): any {
    
    return lookup[value];
  }
}
